export default __webpack_public_path__ + "static/media/bitcoin-cash-bch-logo.2acd4bda.png";